<script>
import TopList from "@/views/components/report/TopList.vue";
import { sortedKeys, sortedCompanys, statusMap } from "./components/report/data";
import { data2, data1, data3 } from "./components/report/data";
import TableList from "@/views/components/report/TableList.vue";
import pdf from "@/utils/pdf";
import bus from "@/utils/bus";
import PreviewHeader from "@/views/components/report/PreviewHeader.vue";
import { getReportOverviewApi, getReportPieDataApi, getReportPublishDetailApi } from "@/api/report";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: "reportPreview",
    components: { PreviewHeader, TableList, TopList },
    data() {
        return {
            data1: {},
            data2: {},
            data3Detail: [],
            previewList: [],
            activeIndex: 0,
            total: 0,
            month: "",
            progress: 0,
            loading: false
        };
    },
    created() {
        this.month = this.$route.query.month;
        this.$nextTick(() => {
            this.getData();
        });
        window.requestAnimationFrame(this.getTotal);
    },
    computed: {
        statusMap() {
            return statusMap;
        },
        pieData() {
            const data = JSON.parse(JSON.stringify(this.data1));
            /**
             * 返回结果为 {
             *     [监控口径]: [{
             *         name: [风险大嘞],
             *         data: {
             *             [风险名称]: {
             *                 [kri]: [预警情况]
             *             }
             *         }
             *     }]
             * }
             *
             */
            let res = {};
            // 监控口径列表
            let level1Keys = Object.keys(data);
            // 统计同一风险大类出现的次数，最后次数多的往上放
            let level2KeysObj = {};
            for (let level1Key of level1Keys) {
                res[level1Key] = [];
                const level2Keys = Object.keys(data[level1Key]).sort((a, b) => sortedKeys.indexOf(a) - sortedKeys.indexOf(b));
                for (let level2Key of level2Keys) {
                    level2KeysObj[level2Key] = (level2KeysObj[level2Key] || 0) + 1;
                    res[level1Key] = level2Keys.map(level2Key => {
                        return {
                            name: level2Key,
                            data: data[level1Key][level2Key]
                        };
                    });
                }
            }
            // 按照风险大类出现的次数由高到低重新排序
            for (let level1Key of level1Keys) {
                res[level1Key] = res[level1Key].sort((a, b) => level2KeysObj[b.name] - level2KeysObj[a.name]);
            }
            level1Keys = level1Keys.sort((a, b) => {
                return res[b].length - res[a].length;
            });

            let list = [];
            while (level1Keys.some(key => res[key].length > 0)) {
                list.push(level1Keys.map(key => {
                    return {
                        key: key,
                        data: res[key].shift()
                    };
                }));
            }
            return list.map(t => {
                return t.sort((a, b) => {
                    return sortedCompanys.indexOf(a.key) - sortedCompanys.indexOf(b.key);
                });
            });
        },
        tableData() {
            const countMap = {};

            const data = JSON.parse(JSON.stringify(this.data1));
            const companys = Object.keys(data).sort((a, b) => sortedCompanys.indexOf(a) - sortedCompanys.indexOf(b));
            companys.forEach(company => {
                const types = Object.keys(data[company]);
                types.forEach(type => {
                    const risks = Object.keys(data[company][type]);
                    risks.map(risk => {
                        const kris = Object.keys(data[company][type][risk]).filter(kri => data[company][type][risk][kri]["当前预警状态"] !== "0");
                        countMap[company] = (countMap[company] || 0) + kris.length;

                    });

                });
            });
            const res = [];
            let current = [];
            companys.forEach(company => {
                if (current.length + countMap[company] > 13) {
                    res.push(current);
                    current = [];
                }
                const types = Object.keys(data[company]);
                types.forEach(type => {
                    const risks = Object.keys(data[company][type]);
                    risks.map(risk => {
                        const kris = Object.keys(data[company][type][risk]).filter(kri => data[company][type][risk][kri]["当前预警状态"] !== "0");
                        kris.map(kri => {
                            if (current.length >= 13) {
                                res.push(current);
                                current = [];
                            } else {
                                current.push({
                                    company,
                                    type,
                                    risk,
                                    kri,
                                    ...data[company][type][risk][kri]
                                });
                            }
                        });

                    });

                });
            });
            if (current.length) res.push(current);
            return res;
        }
    },
    methods: {
        async exportReport() {
            bus.$on("progress", progress => {
                if (progress * 100 < this.progress) return
                this.progress = Number(((progress || 0) * 100).toFixed(2));
            });
            this.loading = true;
            // const loading = this.$loading({
            //     lock: true,
            //     customClass: "progress-loading",
            //     text: "正在导出报告...",
            //     background: "rgba(0,0,0,0.65)",
            //     fullscreen: true
            // });
            try {
                const list = [];
                // list.push(...document.querySelectorAll(".pie"));
                // list.push(...document.querySelectorAll(".table"));
                list.push(...document.querySelectorAll(".ivu-carousel-item > div"));
                await pdf(list.slice(0), {
                    header: document.querySelector(".preview-header-wrapper")
                });
                this.$message.success("导出成功");
            } finally {
                // loading.close();
                this.loading = false;
                bus.$off("progress");
                this.progress = 0
            }
        },
        async getData() {
            await this.getData2();
            await this.getData1();
            this.getData3();
        },
        // 获取概览数据
        async getData1() {
            const data1 = await getReportOverviewApi({ dataVersion: this.month });
            if (data1.code == 200) {
                this.data1 = {
                    ...(data1.data || {})
                };
            }
            return Promise.resolve()
        },
        //   获取饼状图数据
        async getData2() {
            const data2 = await getReportPieDataApi({ dataVersion: this.month });
            if (data2.code == 200) {
                this.data2 = data2.data;
            }
            return Promise.resolve()
        },
        // 获取详情数据
        async getData3() {
            const loading = this.$loading({
                lock: true,
                text: "数据加载中",
                background: "rgba(0,0,0,0.65)"
            });
            try {
                const data3 = await getReportPublishDetailApi({
                    dataversion: this.month
                });
                if (data3.code == 200) {
                    this.data3Detail = (data3.data || []).sort((a, b) => {
                        if (a.companyName === b.companyName) {
                            return sortedKeys.indexOf(a.riskCategory) - sortedKeys.indexOf(b.riskCategory);
                        }
                        return sortedCompanys.indexOf(a.companyName) - sortedCompanys.indexOf(b.companyName);
                    }).map(risk => {
                        let images = risk.images || [];
                        // const temp = [
                        //     "https://community.gmfintl.com/root/contract/file/Snipaste_2024-03-22_10-07-40.png_1712111596823.png",
                        // ];
                        // let images = temp.map((url, idx) => {
                        //     return {
                        //         imgName: idx,
                        //         filePath: url
                        //     };
                        // });
                        if (images.length) {
                            let imgList = [];
                            while (images.length > 0) {
                                imgList.push(images.splice(0, 4));
                            }
                            images = imgList;
                        }
                        return {
                            ...risk,
                            images,
                            deleteTitleJson: risk.deleteTitleJson || []
                        };
                    });
                }
            } finally {
                loading.close();
            }
        },
        getUnit(companyName) {
            return ''
            switch (companyName) {
                case "香港万安公司":
                    return "万港币";
                case "意大利SALOV公司":
                    return "万欧元";
                case "光明食品亚太有限公司":
                    return "万元";
                case "光明国际":
                    return "万澳元";
                default:
                    return "";

            }
        },
        page(step) {
            const carousel = this.$refs.carousel;
            if (!carousel) return;
            this.activeIndex += step;
        },
        getTotal() {
            this.total = this.$refs.carousel?.slides?.length || 0;
            window.requestAnimationFrame(this.getTotal);
        },

        viewImg(url) {
            const previewRef = this.$refs.img;
            if (!previewRef) return;
            this.previewList = [url];
            this.$nextTick(() => {
                previewRef.clickHandler();
            });
        },
        formatDate(date) {
            return `${date.slice(0, 4)}.${date.slice(4, 6)}`;
        }
    }
};
</script>

<template>
    <div class="report-preview-wrapper">
        <div class="export-btn">
            <el-button size="small" @click="() => $router.go(-1)">返回</el-button>
            <el-button type="primary" size="small" @click="exportReport">下载PDF</el-button>
        </div>
        <el-image
            ref="img"
            style="width: 0; height: 0"
            :preview-src-list="previewList">
        </el-image>
        <Spin fix v-if="loading">
            <el-progress type="circle" :percentage="progress"></el-progress>
        </Spin>
        <div class="report-preview">

            <Carousel arrow="never" :autoplay="false" :loop="false" :height="780" ref="carousel" dots="none"
                      :value="activeIndex">
                <Carousel-item v-for="(item, idx) in pieData" :key="'pie_' + idx">
                    <div>
                        <PreviewHeader :company-name="'风险概览'"></PreviewHeader>
                        <TopList :data2="data2" :pieData="[item]" :showPie="idx === 0"></TopList>
                    </div>
                </Carousel-item>
                <Carousel-item v-for="(item, idx) in tableData" :key="'table_' + idx">
                    <div>
                        <PreviewHeader :company-name="'风险概览'"></PreviewHeader>
                        <TableList :tableData="item"></TableList>
                    </div>
                </Carousel-item>
                <template v-for="(risk, riskIdx) in data3Detail">
                    <Carousel-item
                        v-if="!risk.deleteTitleJson.includes('基本信息') || !risk.deleteTitleJson.includes('风险分析') || !risk.deleteTitleJson.includes('趋势分析')"
                        :key="`${riskIdx}_1`">
                        <div :data-key="`${risk.companyName} - ${risk.subRisk}`">
                            <PreviewHeader :company-name="risk.companyName" :risk-name="risk.subRisk"></PreviewHeader>
                            <!--                        <div class="green pb4 fz24">-->
                            <!--                            <p class="green bold "><span>{{ risk.name }}{{ risk["状态"] }}</span></p>-->
                            <!--                        </div>-->
                            <div class="blue pb8 base-info" v-if="!risk.deleteTitleJson.includes('基本信息')">
                                <p class="fz20 pb4"><b>基本信息</b></p>
                                <p>
                                    1.
                                    <span>{{ risk.subRisk }}</span>所有关键风险指标共<span>{{
                                        risk.kriCount
                                    }}</span>个，截止<span>{{
                                        formatDate(risk.dataversion)
                                    }}</span>，<span>{{
                                        risk.alertKriCount
                                    }}</span>个指标处于预警状态，<span>{{
                                        risk.nonAlertKriCount
                                    }}</span>个指标处于非预警状态。
                                </p>
                                <template v-if="risk.alertStatusKri">
                                    <p>
                                        2. 处于预警状态的关键风险指标为：<span>{{
                                            (risk.alertStatusKri || "").replace(/\ /g, "、")
                                        }}</span>。
                                    </p>
                                </template>
                            </div>
                            <div class="blue pb8" v-if="!risk.deleteTitleJson.includes('风险分析')">
                                <p class="fz20 pb4"><b>风险分析</b></p>
                                <p>
                                    <span :class="`riskAnalysis_${riskIdx}`" v-html="risk.riskAnalysis || '-'"></span>
                                </p>
                            </div>
                            <div class="blue pb8" v-if="!risk.deleteTitleJson.includes('趋势分析')">
                                <p class="fz20 pb4"><b>趋势分析</b></p>
                                <p>
                                    <span>{{ risk.trendAnalysis || "-" }}</span>
                                </p>
                            </div>
                        </div>
                    </Carousel-item>
                    <Carousel-item class="img-page" v-if="risk.images && risk.images.length > 0"
                                   v-for="(imgList, imgListIdx) in risk.images" :key="`${riskIdx}_img_${imgListIdx}`">
                        <div>
                            <PreviewHeader :company-name="risk.companyName" :risk-name="risk.subRisk"></PreviewHeader>
                            <div class="img-wrapper">
                                <div class="img-item" v-for="(img, imgIdx) in imgList" :key="`${imgListIdx}_${imgIdx}`"
                                     :style="'margin-bottom: 10px'">
                                    <div class="img-name">
                                        <span>{{ img.imgName }}</span>
                                    </div>
                                    <!--                                <div class="img-content" :style="'background-image: url(' + img.filePath + ')'">-->
                                    <div class="img-content">
                                        <img :src="img.filePath" alt="">
                                        <div class="img-handler">
                                            <i class="el-icon-view" @click="viewImg(img.filePath)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Carousel-item>
                    <Carousel-item class="blue pb8 "
                                   v-if="risk.alertKriCount > 0 && !risk.deleteTitleJson.includes('预警KRI详情')"
                                   :key="`${riskIdx}_2`">
                        <div class="list-wrapper">
                            <PreviewHeader :company-name="risk.companyName" :risk-name="risk.subRisk"></PreviewHeader>
                            <div v-for="(kri, kriIdx) in risk.kriDetailList" :key="kriIdx">
                                <p class="fz20 pb4" v-if="kriIdx === 0"><b>预警KRI详情</b></p>
                                <p class="fz20 pb4">
                                    <span>{{ kri.kriName }}</span> <span>{{ statusMap[kri.kriStatus] }}</span>
                                </p>
                                <p class="blue">
                                    基本信息：截止<span>{{ formatDate(kri.dataversion) }}</span>，<span
                                >{{ kri.kriName }}</span>触发预警，该关键风险指标<span>已持续预警</span> <span
                                >{{ kri.kriWarningDuration }}</span>
                                    <span>天</span>。该关键风险指标的实际数据为<span
                                >{{ kri.kriActualValue }}</span><span>{{
                                        getUnit(risk.companyName)
                                    }}</span>，阈值设定为<span
                                >{{ kri.kriThresholdValue }}</span><span>{{
                                        getUnit(risk.companyName)
                                    }}</span>，实际数据<span
                                >{{ kri.comparisonOperator }}</span>阈值设定<span
                                >{{ kri.difference }}</span><span>{{ getUnit(risk.companyName) }}</span>。
                                </p>
                                <p>
                                    相关响应： <span>{{ kri.relatedResponse || "-" }}</span>
                                </p>
                            </div>
                        </div>
                    </Carousel-item>
                </template>
            </Carousel>
            <div class="bottom-wrapper">
                <div class="pagination-wrapper">
                    <el-button size="mini" @click="page(-1)" :disabled="activeIndex === 0">上一页</el-button>
                    <div>
                        <span>{{ activeIndex + 1 }}</span>
                        <span>/</span>
                        <span>{{ total }}</span>
                    </div>
                    <el-button size="mini" @click="page(1)" :disabled="activeIndex === total - 1">下一页</el-button>
                </div>
            </div>

        </div>
    </div>

</template>

<style scoped lang="less">
@import "../assets/less/report.less";

.report-preview-wrapper {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    min-width: 1180px;
    background-color: #fff;
    font-size: 18px;
    position: relative;

    .export-btn {
        position: fixed;
        top: 20px;
        left: 20px;
        z-index: 10;
    }

    ::v-deep {
        .ivu-spin-fix {
            z-index: 10;
        }
    }
}

.report-preview {
    width: 1180px;
    min-height: 780px;
    margin: 0 auto;
    position: relative;

    ::v-deep {
        .ivu-carousel {
            ::-webkit-scrollbar {
                width: 4px;
            }

            ::-webkit-scrollbar-track {
                background: rgb(179, 177, 177);
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb {
                background: rgb(136, 136, 136);
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: rgb(100, 100, 100);
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:active {
                background: rgb(68, 68, 68);
                border-radius: 4px;
            }

            .ivu-carousel-item {
                overflow-y: auto;
                overflow-x: hidden;
            }
        }

    }

    span {
        white-space: pre-wrap;
    }

    .bottom-wrapper {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        transform: translateY(48px);

        .pagination-wrapper {
            display: flex;
            margin: 0 auto;
            column-gap: 12px;
        }
    }

    .img-wrapper {
        padding-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .img-item {
            height: 312px;
            width: 49%;
            flex-grow: 0;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .img-name {
                font-size: 16px;
                margin-bottom: 6px;
                flex-shrink: 0;
                flex-grow: 0;
            }

            .img-content {
                flex-grow: 1;
                border: 1px solid #eee;
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 4px;
                position: relative;

                img {
                    width: auto;
                    position: absolute;
                    height: 280px;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    object-fit: contain;
                }

                .img-handler {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    background-color: rgba(0, 0, 0, 0.6);
                    align-items: center;
                    justify-content: center;
                    column-gap: 10px;

                    i {
                        font-size: 20px;
                        color: #aaa;
                        cursor: pointer;

                        &:hover {
                            color: #fff
                        }
                    }
                }

                &:hover {
                    .img-handler {
                        display: flex;
                    }
                }
            }
        }
    }

}
</style>
<style lang="less">
.progress-loading {
    .el-loading-spinner {
        display: none;
    }
}
</style>